import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function PhoenixPage() {
  return <LocationPageTemplate city="Phoenix" cityShort="Phoenix" slug="phoenix" data-id="element-1018" />;
}